import React from "react";
import styled from "styled-components";
import Helmet from "react-helmet";

import { Route } from "react-router-dom";

import "./App.css";

import WritingBoard from "./WritingBoard";

const Main = styled.main`
  min-height: 100vh;
  height: 100%;

  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue";
  background-color: #eedddd;
`;

function App() {
  return (
    <Main>
      <Helmet>
        <title>Беглость</title>
      </Helmet>
      <Route path="/" render={props => <WritingBoard {...props} />} />
    </Main>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js